import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormFourStateCheckboxComplexBaseComponent } from '../base-complex/form-four-state-checkbox-complex-base.component';
import { ShFormFourStateCheckboxBaseComponent } from '../base-simple/form-four-state-checkbox-base.component';

@Component({
    selector: 'sh-form-four-state-checkbox',
    templateUrl: './form-four-state-checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ShFormFourStateCheckboxComplexBaseComponent,
    ReactiveFormsModule,
    ShFormFourStateCheckboxBaseComponent,
    AsyncPipe,
    ShFormGroupComponent
]
})
export class ShFormFourStateCheckboxComponent extends ShBaseFormComponent {}
